export const recipeRangeSearchFields = [
  'pagination(totalResults)',
  'products(commercialCode,name,url,images(FULL),onSale)'
];
